import { render } from "./ClientEdit.vue?vue&type=template&id=0bf02389"
import script from "./ClientEdit.vue?vue&type=script&lang=js"
export * from "./ClientEdit.vue?vue&type=script&lang=js"

import "./ClientEdit.vue?vue&type=style&index=0&id=0bf02389&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__